import { Link } from '@tanstack/react-router';
import styles from './WorkspacePages.module.css';

export function HelpPage() {
  return (
    <article className={styles.page}>
      <header className={styles.header}>
        <h1 className={styles.title}>Help</h1>
        <p className={styles.intro}>
          Find your way around Traceira and see what this development environment can do today.
        </p>
      </header>

      <section className={styles.section} aria-labelledby="current-capabilities">
        <h2 id="current-capabilities">Current capabilities</h2>
        <p className={styles.sectionCopy}>
          Discovery and testing are unavailable in this development environment. Opening a
          workspace, changing views, or refreshing the page does not start discovery or contact
          customer websites. No scans, monitoring, or engagements run in the background.
        </p>
        <div className={styles.links}>
          <Link to="/findings">Findings and discovery status</Link>
          <Link to="/engagements">Engagements</Link>
        </div>
      </section>

      <section className={styles.section} aria-labelledby="workspace-records">
        <h2 id="workspace-records">Workspace records</h2>
        <p className={styles.sectionCopy}>
          Evidence and reports show the records available in the selected workspace. Open a finding
          to see its cited evidence when records are available.
        </p>
        <div className={styles.links}>
          <Link to="/evidence">Evidence</Link>
          <Link to="/reports">Reports</Link>
        </div>
      </section>
    </article>
  );
}
